import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${Tokens.ColorBorder};
`

export const BrandTabsPaginationContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  border-bottom: 1px solid ${Tokens.ColorBorder};
`

export const BrandTabsViewport = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

export const BrandTabsTrack = styled.div`
  display: flex;
  gap: 8px;
`

export const BrandPagerButton = styled.button`
  width: 30px;
  height: 30px;
  margin-bottom: 8px;
  border-radius: 999px;
  border: 1px solid ${Tokens.ColorUIPrimaryLight};
  background: ${Tokens.ColorWhite};
  color: ${Tokens.ColorUIPrimaryDim};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s ease;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(1, 167, 121, 0.08);

  &:hover:not(:disabled) {
    border-color: ${Tokens.ColorUIPrimary};
    color: ${Tokens.ColorUIPrimary};
    background: ${Tokens.ColorUISuccessLight};
    box-shadow: 0 2px 6px rgba(1, 167, 121, 0.16);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(1, 167, 121, 0.12);
  }

  &:disabled {
    cursor: not-allowed;
    border-color: ${Tokens.ColorBorder};
    background: ${Tokens.ColorBackground};
    color: ${Tokens.ColorTextTertiary};
    box-shadow: none;
    transform: none;
  }
`

export const TabButton = styled.button<{ $active: boolean; $disabled?: boolean; $fluid?: boolean }>`
  padding: 12px 24px;
  border: none;
  background: ${({ $active, $disabled }) =>
    $disabled ? '#e0e0e0'
    : $active ? '#01c38d'
    : 'transparent'};
  color: ${({ $active, $disabled }) =>
    $disabled ? '#9e9e9e'
    : $active ? 'white'
    : '#6b7280'};
  border-radius: 8px 8px 0 0;
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  position: relative;
  flex: ${({ $fluid }) => ($fluid ? 1 : 'initial')};
  min-width: ${({ $fluid }) => ($fluid ? 0 : 'auto')};
  justify-content: ${({ $fluid }) => ($fluid ? 'center' : 'initial')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${({ $active, $disabled }) =>
      $disabled ? '#e0e0e0'
      : $active ? '#01c38d'
      : '#f3f4f6'};
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 10px,
        rgba(0, 0, 0, 0.03) 10px,
        rgba(0, 0, 0, 0.03) 20px
      );
      pointer-events: none;
    }
  `}
`

export const StatusDot = styled.span<{ $success: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 999px;
  border: 2px solid ${({ $success }) => ($success ? Tokens.ColorUIPrimaryDim : Tokens.ColorUIDangerDim)};
  box-shadow: 0 0 4px ${({ $success }) => ($success ? Tokens.ColorUIPrimaryDim : Tokens.ColorUIDangerDim)};
  background-color: ${({ $success }) => ($success ? Tokens.ColorUIPrimary : Tokens.ColorUIDanger)};
  display: inline-block;
  flex-shrink: 0;
  margin-left: 4px;
`
